export * from './change-password-dialog/change-password-dialog.component';
